<template>
  <v-dialog :value="mostrarDialogoAssinarDocumento" persistent :max-width="400">
    <v-card>
      <v-card-title class="primary modal-title" primary-title>
        Assinar Documento{{multiplo ? 's' : ''}}
      </v-card-title>
      <v-card-text class="pb-0 az-form-content">
        <div class="az-text mb-3">
          <p><strong>Deseja realmente assinar {{multiplo? 'os documentos selecionados' : 'o documento'}}?</strong></p>
        </div>
      </v-card-text>
      <v-card-actions class="acoes justify-center">
        <v-btn color="#777" flat @click="fecharModal">
          Fechar
        </v-btn>
        <v-btn class="botao-primario confirmar" flat @click="confirmarAcao">
          Confirmar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ModalConfirmarAssinarDocumento',
  props: ['mostrarDialogoAssinarDocumento', 'multiplo'],
  methods: {
    fecharModal() {
      this.$emit('fechar')
    },
    async confirmarAcao() {
      this.$emit('confirmar')
    }
  }
}
</script>

<style lang="stylus" scoped>
.text-modal-confirm
  color #3A6861
  font-weight 600

.box-modal-confirm
  display flex
  flex-direction column
  justify-content center
  align-items center
  min-height 100px

.botao-primario
  padding 0 25px
  border 1px solid #7aa329
  background-color #7aa329 !important
  color #fff !important
  box-sizing border-box
  margin-left 15px !important

.acoes
  padding 20px 0 !important
</style>